(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jmt-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__jmtColl) return;
      root.__jmtColl = true;
      var form = root.querySelector('[data-coll-form]');
      if (!form) return;
      var toggle = form.querySelector('[data-coll-toggle]');
      var panel = form.querySelector('[data-coll-panel]');
      var sort = form.querySelector('[data-coll-sort]');

      if (toggle && panel) {
        if (form.querySelector('.jmt-coll__chips')) { /* keep panel closed, chips show what is active */ }
        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.hidden = open;
        });
      }

      function dropEmpty() {
        var inputs = form.querySelectorAll('input[type=number]');
        for (var i = 0; i < inputs.length; i++) { if (inputs[i].value === '') inputs[i].disabled = true; }
      }

      form.addEventListener('submit', dropEmpty);
      if (sort) sort.addEventListener('change', function () { dropEmpty(); form.submit(); });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-jmt-coll]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jmt-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.__jmtPdp) return;
      root.__jmtPdp = true;

      var dataEl = root.querySelector('[data-pdp-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      var idInput = root.querySelector('[data-pdp-id]');
      var addBtn = root.querySelector('[data-pdp-add]');
      var priceEl = root.querySelector('[data-pdp-price]');
      var track = root.querySelector('[data-pdp-track]');
      var count = root.querySelector('[data-pdp-count]');
      var thumbs = root.querySelectorAll('[data-pdp-thumb]');
      var slides = root.querySelectorAll('.jmt-pdp__slide');
      var qty = root.querySelector('[data-pdp-qty-input]');

      function goTo(i, smooth) {
        if (!track || !slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      }

      function syncGallery() {
        if (!track || !track.clientWidth) return;
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        for (var t = 0; t < thumbs.length; t++) {
          if (t === i) thumbs[t].setAttribute('aria-current', 'true');
          else thumbs[t].removeAttribute('aria-current');
        }
      }

      if (track) track.addEventListener('scroll', function () { window.requestAnimationFrame(syncGallery); }, { passive: true });
      for (var t = 0; t < thumbs.length; t++) {
        thumbs[t].addEventListener('click', function (e) { goTo(Number(e.currentTarget.getAttribute('data-pdp-thumb')), true); });
      }

      function selectedOptions() {
        var chosen = [];
        var inputs = root.querySelectorAll('[data-pdp-option]:checked');
        for (var i = 0; i < inputs.length; i++) chosen[Number(inputs[i].getAttribute('data-pdp-option'))] = inputs[i].value;
        return chosen;
      }

      function findVariant(chosen) {
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var j = 0; j < chosen.length; j++) { if (variants[i].options[j] !== chosen[j]) { ok = false; break; } }
          if (ok) return variants[i];
        }
        return null;
      }

      function priceHtml(v) {
        var html = '<span class="jmt-price"><span class="jmt-price__now">' + v.price + '</span>';
        if (v.onSale) html += '<s class="jmt-price__was">' + v.compare + '</s><span class="jmt-price__off">-' + v.off + '%</span>';
        return html + '</span>';
      }

      function update() {
        var chosen = selectedOptions();
        for (var i = 0; i < chosen.length; i++) {
          var label = root.querySelector('[data-pdp-selected="' + i + '"]');
          if (label) label.textContent = chosen[i];
        }
        var v = findVariant(chosen);
        if (!v) {
          addBtn.disabled = true;
          addBtn.textContent = 'Unavailable';
          return;
        }
        idInput.value = v.id;
        priceEl.innerHTML = priceHtml(v);
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (v.media) {
          for (var s = 0; s < slides.length; s++) {
            if (Number(slides[s].getAttribute('data-media-id')) === v.media) { goTo(s, false); break; }
          }
        }
      }

      root.addEventListener('change', function (e) { if (e.target.matches('[data-pdp-option]')) update(); });

      root.addEventListener('click', function (e) {
        var step = e.target.closest('[data-pdp-qty]');
        if (!step || !qty) return;
        var next = (parseInt(qty.value, 10) || 1) + Number(step.getAttribute('data-pdp-qty'));
        qty.value = Math.max(1, next);
      });
      if (qty) qty.addEventListener('change', function () { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-jmt-pdp]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jmt-trust-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTrustStrip(root) {
      if (root.__jmtTband) return;
      var vp = root.querySelector('[data-tband-viewport]');
      var groups = root.querySelectorAll('.jmt-tband__group');
      if (!vp || groups.length < 4) return;
      root.__jmtTband = true;

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var speed = parseFloat(root.getAttribute('data-speed')) || 46;
      var pos = 0;
      var last = 0;
      var resumeAt = 0;
      var dirty = false;
      var visible = true;

      function loopWidth() { return groups[0].offsetWidth * 2; }

      function wrap() {
        var w = loopWidth();
        if (!w) return;
        if (vp.scrollLeft >= w) { vp.scrollLeft -= w; pos = vp.scrollLeft; }
        else if (vp.scrollLeft <= 0) { vp.scrollLeft += w; pos = vp.scrollLeft; }
      }

      function hold() { resumeAt = Infinity; dirty = true; }
      function release(delay) { resumeAt = performance.now() + delay; dirty = true; }

      vp.addEventListener('touchstart', hold, { passive: true });
      vp.addEventListener('touchend', function () { release(2200); }, { passive: true });
      vp.addEventListener('touchcancel', function () { release(2200); }, { passive: true });
      vp.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') hold(); }, { passive: true });
      window.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse' && resumeAt === Infinity && !root.matches(':hover')) release(800); }, { passive: true });
      vp.addEventListener('mouseenter', hold);
      vp.addEventListener('mouseleave', function () { release(800); });
      vp.addEventListener('wheel', function () { release(2200); }, { passive: true });
      vp.addEventListener('focusin', hold);
      vp.addEventListener('focusout', function () { release(800); });
      vp.addEventListener('scroll', function () { if (resumeAt !== 0 && performance.now() < resumeAt) wrap(); }, { passive: true });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }, { threshold: 0 }).observe(root);
      }

      vp.scrollLeft = groups[0].offsetWidth;
      pos = vp.scrollLeft;

      function frame(now) {
        requestAnimationFrame(frame);
        var dt = Math.min((now - last) / 1000, 0.1);
        last = now;
        if (reduce.matches || !visible || document.hidden || now < resumeAt) return;
        if (dirty) { pos = vp.scrollLeft; dirty = false; }
        pos += speed * dt;
        var w = loopWidth();
        if (w && pos >= w) pos -= w;
        vp.scrollLeft = Math.round(pos);
      }
      requestAnimationFrame(function (t) { last = t; frame(t); });
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-jmt-tband]');
      for (var i = 0; i < roots.length; i++) initTrustStrip(roots[i]);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
